// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBone = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M6 6.5a3.5 3.5 0 016-2.45 3.5 3.5 0 113 5.914v4.071a3.501 3.501 0 11-3 5.914 3.5 3.5 0 11-3-5.914v-4.07A3.5 3.5 0 016 6.5M9.5 5a1.5 1.5 0 100 3H11v8H9.5a1.5 1.5 0 101.47 1.801l.163-.801h1.734l.163.801A1.5 1.5 0 1014.5 16H13V8h1.5a1.5 1.5 0 10-1.47-1.801L12.867 7h-1.734l-.163-.801A1.5 1.5 0 009.5 5"
    />
  );
export default SvgIconBone;
